<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
	  <z-page :title="title">
         <w-dialog
    v-model="dialog.show"
    :fullscreen="dialog.fullscreen"
    :width="dialog.width"
    :persistent="dialog.persistent"
    :persistent-no-animation="dialog.persistentNoAnimation"
    title-class="primary-dark1--bg white">
    <template #title>
      <w-icon class="mr2">fal fa-cog</w-icon>
      TAMBAH TERNAKAN
    </template>

    <w-form 
      ref="form" 
      v-model="dialog.valid"
      @validate="submit"
      @success="success"
    >
    
    
        <div class="w-flex wrap smd-column" >
          <div class="grow " >
         <w-flex wrap :gap="2">
         <div class="grow mb4" style="min-width: 200px">
            <w-select class="mt4" :items="premis" label="Premis *"  v-model="form.premis_id" :validators="[validators.required]"/>
            
            <w-select class="mt4" :items="lkp_ternakan" label="Jenis Ternakan *"  v-model="form.lkp_ternakan_id" @input="getBaka(form.lkp_ternakan_id)" :validators="[validators.required]"/>

            <w-input class="mt4" label="ID Ternakan *" type="text" v-model="form.id_tenakan" />

            <w-select class="mt4" :items="lkp_jurusan" label="Jurusan Ternakan *"  v-model="form.lkp_jurusan_id" :validators="[validators.required]"/> 
            
            <w-select class="mt4" :items="lkp_baka" label="Baka *"  v-model="form.lkp_baka_id"  :validators="[validators.required]"/> 

            
            <w-select class="mt4" :items="lkp_gred" label="Generasi *"  v-model="form.lkp_gred_id"  :validators="[validators.required]" disabled/>
            
            <w-input class="mt4" label="Nama Ternakan (Jika ada) " type="text" v-model="form.nama" />
            
            <w-input class="mt4" label="Tarikh Lahir *" type="date" v-model="form.tarikh_lahir" :validators="[validators.required]"/>
            
            <w-select class="mt4" :items="jantina" label="Jantina *"  v-model="form.jantina"  :validators="[validators.required]"/>
            
            <w-select class="mt4" :items="lkp_status" label="Status *"  v-model="form.lkp_status_id"  :validators="[validators.required]"/>
         </div>
      </w-flex>
      </div>
   </div>
   </w-form>

    
    <template #actions>
      <div class="spacer" />
      <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog.show = false">TUTUP</w-button>
      <w-button 
      class="ml1" 
      :loading="dialog.loading"
      :disabled="dialog.valid === false"
      @click="$refs.form.validate()"
      >
        SIMPAN
          </w-button>
         </template>
       </w-dialog>

       <z-table
    ref="tbluser"
    title="TERNAKAN"
    :headers="table.headers"  
    :items="table.items"
    :meta="table.meta"
    class=""
  >


 
  <template #button>
        <w-button dark class="green--bg ml1" @click="add()">
            <w-icon class="mr1">fal fa-plus</w-icon> TAMBAH
        </w-button>
    </template>
   
  
    <template #header-label="{ header, label, index }">
      <template v-if="header.key == 'action'">
      <!-- <w-icon xs>fal fa-pencil</w-icon> -->
      Tindakan
      </template>
      <template v-else>
      {{ label }}
      </template>
    
    </template>

    <template #item-cell.action="{ item, label, header, index }">
      <w-flex class="flex justify-center">
        <w-button class="fs-2 pr3 bs" bg-color="orange-light3" tile @click="edit(item)">
          <w-icon xs class="mr2">fal fa-pencil</w-icon> KEMASKINI

        </w-button>
        &nbsp;  
        <w-button class="fs-2" bg-color="red-light1" dark tile @click="destroy(item)">
          <w-icon xs class="mr-auto"> fal fa-trash</w-icon>PADAM
        </w-button>
       &nbsp;
       
        
             </w-flex>
         </template>
      </z-table>
	  </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    id: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'daftar.ternakan',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Ternakan', route: 'daftar/ternakan' },
      ],
      title : 'Tambah Ternakan',
      form : {
        id : 0,
        premis_id : '',
        lkp_ternakan_id : '',
        lkp_baka_id : '',
        lkp_gred_id : '',
        kode : '',
        nama : '',
        tarikh_lahir : '',
        jantina : '',
        lkp_jurusan_id : '',
        lkp_status_id : '',
        nama_bapa : '',
        id_bapa : '',
        nama_ibu : '',
        id_ibu : '',
      },
      lkp_jurusan :[],
      lkp_ternakan : [],
      lkp_baka : [],
      premis : [],
      lkp_gred : [],
      lkp_status : [],
      lkp_negeri : [],
      lkp_bandar : [],
      lkp_poskod : [],
      jantina : []
      
    }
  },
  methods: {
    add(){
          this.form = {
              id : 0

          }
          
          this.dialog.show = true
          this.form.saveButton = "Save"
      },

    onSuccess(){
      if (this.form.id > 0) 
      {
        this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
        .then(res => {
          if (typeof this.onAfterEdit === "function") {
            this.onAfterEdit()
          }
          this.$inertia.visit(this.$route('ternakan.show', this.form.id))
        })
      }
      else 
      {
        this.$zcomm.post(this.resourceurl+'.store' , this.form)
        .then(res => {
          if (typeof this.onAfterAdd === "function") {
            this.onAfterAdd()
          }
          this.$inertia.visit(this.$route('ternakan.show', res.id))

        })
      }
    },

    getTernakan(){
      this.$zcomm.get(this.api_service + 'lookup/ternakan', {}).then(res => {
        this.lkp_ternakan = res
      })
    },

    getBaka(i){
      this.$zcomm.get(this.api_service + 'lookup/baka/'+i, {}).then(res => {
        this.lkp_baka = res
      })
    },

    getGred(){
      this.$zcomm.get(this.api_service + 'lookup/gred', {}).then(res => {
        this.lkp_gred = res
      })
    },

    getStatus(){
      this.$zcomm.get(this.api_service + 'lookup/status_ternakan', {}).then(res => {
        this.lkp_status = res
      })
    },

    getJantina(){
      this.$zcomm.get(this.api_service + 'lookup/jantina', {}).then(res => {
        this.jantina = res
      })
    },

    getPremis(){
      this.$zcomm.get(this.api_service + 'lookup/premis', {}).then(res => {
        this.premis = res
      })
    },

    getJurusan(){
      this.$zcomm.get(this.api_service + 'lookup/jurusan', {}).then(res => {
        this.lkp_jurusan = res
      })
    },

    getData(){
      if(this.id > 0){
        this.$zcomm.get(this.api_service + 'ternakan/show/'+this.id, {}).then(res => {
          if(res.lkp_ternakan_id > 0){
            this.getBaka(res.lkp_ternakan_id)
          }
          this.form = res

        })
      }
    },
  
  },

  watch: {

  },
  mounted() {
    if(this.id > 0)
    {
      this.title = 'Kemaskini Ternakan'
    }
    else
    {
      this.title = 'Tambah Ternakan'
    }
    this.getPremis()
    this.getJantina()
    this.getTernakan()
    this.getGred()
    this.getStatus()
    this.getData()
    this.getJurusan()
    this.params = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
    if(this.params.premis_id){
      this.form.premis_id =  parseInt(this.params.premis_id)
    }
  }
    
}
</script>
